// Navigation service for programmatic navigation from sagas
// Compatible with React Router v6

let navigate = null;

// Function to set the navigate function from a React component
export const setNavigate = (navigateFunction) => {
  navigate = navigateFunction;
};

// Function to navigate programmatically (can be called from sagas)
export const navigateTo = (path, options = {}) => {
  if (navigate) {
    navigate(path, options);
  } else {
    console.warn('Navigation function not initialized. Make sure to call setNavigate() from a React component.');
  }
};

// Convenience function that matches the old push behavior
export const push = (path) => {
  navigateTo(path);
};

// Convenience function that matches the old replace behavior  
export const replace = (path) => {
  navigateTo(path, { replace: true });
};

export default {
  setNavigate,
  navigateTo,
  push,
  replace
};